/* istanbul ignore file */

// vanity export of classnames to be able to auto-import it with a slighly shorter naming :)

export { default } from 'classnames';
